import React from "react";
import { Button } from "../../../../../design/button";
import { Field, Label } from "../../../../../design/fieldset";
import OnboardingContainer from "../../../components/OnboardingContainer";
import { Checkbox, CheckboxField } from "../../../../../design/checkbox";
import { Concern } from "../../../../../models/Concern";
import { Intake } from "../../../../../models/Intake";

const OnboardingMajorConcernsStep: React.FC<{
  isSaving?: boolean;
  formData: Omit<
    Intake,
    "_id" | "createdAt" | "updatedAt" | "createdBy" | "updatedBy" | "status"
  >;
  setFormData: React.Dispatch<
    React.SetStateAction<
      Omit<
        Intake,
        "_id" | "createdAt" | "updatedAt" | "createdBy" | "updatedBy" | "status"
      >
    >
  >;
  onBack: () => void;
  onStepComplete: () => void;
}> = ({ formData, setFormData, onBack, onStepComplete, isSaving }) => {
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onStepComplete();
  };

  return (
    <OnboardingContainer title={"Major Concerns"}>
      <>
        <p className="mb-6 text-gray-700">
          What areas of the divorce are you most concerned about?
        </p>
        <form onSubmit={handleSubmit} className="space-y-6">
          <Field>
            <Label>Select any that apply:</Label>
            <CheckboxField>
              <Label>Custody of Children</Label>
              <Checkbox
                checked={formData.concerns.includes("child_custody")}
                onChange={(checked) => {
                  const updatedConcerns: Concern[] = checked
                    ? [...formData.concerns, "child_custody"]
                    : formData.concerns.filter((c) => c !== "child_custody");
                  setFormData({ ...formData, concerns: updatedConcerns });
                }}
              />
            </CheckboxField>
            <CheckboxField>
              <Label>Child Support</Label>
              <Checkbox
                checked={formData.concerns.includes("child_support")}
                onChange={(checked) => {
                  const updatedConcerns: Concern[] = checked
                    ? [...formData.concerns, "child_support"]
                    : formData.concerns.filter((c) => c !== "child_support");
                  setFormData({ ...formData, concerns: updatedConcerns });
                }}
              />
            </CheckboxField>
            <CheckboxField>
              <Label>Division of Property</Label>
              <Checkbox
                checked={formData.concerns.includes("property_division")}
                onChange={(checked) => {
                  const updatedConcerns: Concern[] = checked
                    ? [...formData.concerns, "property_division"]
                    : formData.concerns.filter(
                        (c) => c !== "property_division",
                      );
                  setFormData({ ...formData, concerns: updatedConcerns });
                }}
              />
            </CheckboxField>
            <CheckboxField>
              <Label>SpousalSupport</Label>
              <Checkbox
                checked={formData.concerns.includes("spousal_support")}
                onChange={(checked) => {
                  const updatedConcerns: Concern[] = checked
                    ? [...formData.concerns, "spousal_support"]
                    : formData.concerns.filter((c) => c !== "spousal_support");
                  setFormData({ ...formData, concerns: updatedConcerns });
                }}
              />
            </CheckboxField>
            <CheckboxField>
              <Label>Safety Concerns</Label>
              <Checkbox
                checked={formData.concerns.includes("safety")}
                onChange={(checked) => {
                  const updatedConcerns: Concern[] = checked
                    ? [...formData.concerns, "safety"]
                    : formData.concerns.filter((c) => c !== "safety");
                  setFormData({ ...formData, concerns: updatedConcerns });
                }}
              />
            </CheckboxField>
          </Field>
          <Button type="submit" className="w-full" disabled={isSaving}>
            {isSaving ? "Saving..." : "Continue"}
          </Button>
        </form>
      </>
    </OnboardingContainer>
  );
};

export default OnboardingMajorConcernsStep;
